import { DOCUMENT } from '@angular/common';
import { DestroyRef, Injectable, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { debounceTime, fromEvent, merge } from 'rxjs';

import { CustomActiveStateDirective } from './custom-active-state.directive';

@Injectable({
    providedIn: 'root',
})
export class CustomActiveStateRegistry {
    private readonly _doc = inject(DOCUMENT);
    private readonly _destroy = inject(DestroyRef);

    private _callbackRegistry: CustomActiveStateDirective[] = [];

    constructor() {
        const activeEnd$ = merge(
            fromEvent<MouseEvent>(this._doc, 'mouseup'),
            fromEvent<MouseEvent>(this._doc, 'touchend'),
            fromEvent<MouseEvent>(this._doc, 'touchcancel'),
        ).pipe(debounceTime(100), takeUntilDestroyed(this._destroy));

        activeEnd$.subscribe(() => {
            if (!this._callbackRegistry.length) {
                return;
            }

            this._callbackRegistry.forEach((directive) => {
                directive.triggerInteractionEnd();
            });

            this._callbackRegistry = [];
        });
    }

    register(directive: CustomActiveStateDirective): void {
        if (this._callbackRegistry.includes(directive)) {
            return;
        }

        this._callbackRegistry.push(directive);
    }

    unregister(directive: CustomActiveStateDirective): void {
        this._callbackRegistry = this._callbackRegistry.filter((d) => d !== directive);
    }
}
